<template>
    <div>
        <form class="form-horizontal" v-on:submit.prevent data-vv-scope="plssComponent" :id="'plssComponentForm' + id" v-if="formReset">
            <h4 v-if="showTitle">Add PLSS Locations</h4>
            <div class="form-group">
                <label class="col-md-3 control-label">Meridian</label>
                <div class="col-md-4">
                    <select name="Meridian" class="form-control" v-validate="'required'" v-model.number="plssData.MeridianId">
                        <option disabled value="">Select a Meridian</option>
                        <option v-for="meridian in meridianList" v-bind:value="meridian.meridianId" :key="meridian.meridianId">
                            {{ meridian.description}}
                        </option>
                    </select>
                    <span v-show="errors.has('plssComponent.Meridian')" class="has-error">Meridian is required</span>
                </div>
            </div>
            <div class="form-group" >
                <label class="col-md-3 control-label">Township</label>
                <div class="col-md-4">
                    <input name="Township" type="text" class="form-control" data-vv-delay="1000" v-model="plssData.Township" placeholder="Township" v-validate="{required: true, validSection: [plssData.MeridianId, 'township']}" aria-required="true">
                    <span v-show="errors.has('plssComponent.Township')" class="has-error">{{errors.first('plssComponent.Township') }}</span>
                </div>
            </div>
            <div class="form-group" >
                <label class="col-md-3 control-label">Township Direction</label>
                <div class="col-md-4">
                <select name="TownshipDirection" class="form-control" v-model="plssData.TownshipDirection" v-validate="{required: true, validPlssDirection: [plssData.MeridianId, 'township']}" aria-required="true">
                    <option value="">Select a value</option>
                    <option value="N">N</option>
                    <option v-if="plssData.MeridianId !== 1" value="S">S</option>
                </select>
                <span v-show="errors.has('plssComponent.TownshipDirection')" class="has-error">Township Direction is required</span>
                </div>
            </div>
            <div class="form-group" >
                <label class="col-md-3 control-label">Range</label>
                <div class="col-md-4">
                    <input name="range" type="text" class="form-control" data-vv-delay="1000" v-model="plssData.Range" placeholder="range" v-validate="{required: true, validSection: [plssData.MeridianId, 'range']}" aria-required="true">
                    <span v-show="errors.has('plssComponent.range')" class="has-error">{{errors.first('plssComponent.range') }}</span>
                </div>
            </div>
            <div class="form-group" >
                <label class="col-md-3 control-label">Range Direction</label>
                <div class="col-md-4">
                    <select name="RangeDirection" class="form-control" v-model="plssData.RangeDirection" v-validate="{required: true, validPlssDirection: [plssData.MeridianId, 'range']}" aria-required="true">
                        <option value="">Select a value</option>
                        <option v-if="plssData.MeridianId !== 1" value="E">E</option>
                        <option value="W">W</option>
                    </select>
                    <span v-show="errors.has('plssComponent.RangeDirection')" class="has-error">Range Direction is required</span>
                </div>
            </div>
            <div class="form-group" >
                <label class="col-md-3 control-label">Sections</label>
                <div class="col-md-6">
                    <div class="sectionRow">
                        <span class="sectionCheckboxLabel">06</span>
                        <input class="sectionCheckbox" type="checkbox" id="checkBoxSection_6" v-model="plssSectionList" v-bind:value="plssSectionLookupList[5]">
                        <span class="sectionCheckboxLabel">05</span>
                        <input class="sectionCheckbox" type="checkbox" id="checkBoxSection_5" v-model="plssSectionList" v-bind:value="plssSectionLookupList[4]">
                        <span class="sectionCheckboxLabel">04</span>
                        <input class="sectionCheckbox" type="checkbox" id="checkBoxSection_4" v-model="plssSectionList" v-bind:value="plssSectionLookupList[3]">
                        <span class="sectionCheckboxLabel">03</span>
                        <input class="sectionCheckbox" type="checkbox" id="checkBoxSection_3" v-model="plssSectionList" v-bind:value="plssSectionLookupList[2]">
                        <span class="sectionCheckboxLabel">02</span>
                        <input class="sectionCheckbox" type="checkbox" id="checkBoxSection_2" v-model="plssSectionList" v-bind:value="plssSectionLookupList[1]">
                        <span class="sectionCheckboxLabel">01</span>
                        <input class="sectionCheckbox" type="checkbox" id="checkBoxSection_1" v-model="plssSectionList" v-bind:value="plssSectionLookupList[0]">
                    </div>
                    <div class="sectionRow">
                        <span class="sectionCheckboxLabel">07</span>
                        <input type="checkbox" id="checkBoxSection_7" v-model="plssSectionList" v-bind:value="plssSectionLookupList[6]">
                        <span class="sectionCheckboxLabel">08</span>
                        <input type="checkbox" id="checkBoxSection_8" v-model="plssSectionList" v-bind:value="plssSectionLookupList[7]">
                        <span class="sectionCheckboxLabel">09</span>
                        <input type="checkbox" id="checkBoxSection_9" v-model="plssSectionList" v-bind:value="plssSectionLookupList[8]">
                        <span class="sectionCheckboxLabel">10</span>
                        <input type="checkbox" id="checkBoxSection_10" v-model="plssSectionList" v-bind:value="plssSectionLookupList[9]">
                        <span class="sectionCheckboxLabel">11</span>
                        <input type="checkbox" id="checkBoxSection_11" v-model="plssSectionList" v-bind:value="plssSectionLookupList[10]">
                        <span class="sectionCheckboxLabel">12</span>
                        <input type="checkbox" id="checkBoxSection_12" v-model="plssSectionList" v-bind:value="plssSectionLookupList[11]">
                    </div>
                    <div class="sectionRow">
                        <span class="sectionCheckboxLabel">18</span>
                        <input type="checkbox" id="checkBoxSection_18" v-model="plssSectionList" v-bind:value="plssSectionLookupList[17]">
                        <span class="sectionCheckboxLabel">17</span>
                        <input type="checkbox" id="checkBoxSection_17" v-model="plssSectionList" v-bind:value="plssSectionLookupList[16]">
                        <span class="sectionCheckboxLabel">16</span>
                        <input type="checkbox" id="checkBoxSection_16" v-model="plssSectionList" v-bind:value="plssSectionLookupList[15]">
                        <span class="sectionCheckboxLabel">15</span>
                        <input type="checkbox" id="checkBoxSection_15" v-model="plssSectionList" v-bind:value="plssSectionLookupList[14]">
                        <span class="sectionCheckboxLabel">14</span>
                        <input type="checkbox" id="checkBoxSection_14" v-model="plssSectionList" v-bind:value="plssSectionLookupList[13]">
                        <span class="sectionCheckboxLabel">13</span>
                        <input type="checkbox" id="checkBoxSection_13" v-model="plssSectionList" v-bind:value="plssSectionLookupList[12]">
                    </div>
                    <div class="sectionRow">
                        <span class="sectionCheckboxLabel">19</span>
                        <input type="checkbox" id="checkBoxSection_19" v-model="plssSectionList" v-bind:value="plssSectionLookupList[18]">
                        <span class="sectionCheckboxLabel">20</span>
                        <input type="checkbox" id="checkBoxSection_20" v-model="plssSectionList" v-bind:value="plssSectionLookupList[19]">
                        <span class="sectionCheckboxLabel">21</span>
                        <input type="checkbox" id="checkBoxSection_21" v-model="plssSectionList" v-bind:value="plssSectionLookupList[20]">
                        <span class="sectionCheckboxLabel">22</span>
                        <input type="checkbox" id="checkBoxSection_22" v-model="plssSectionList" v-bind:value="plssSectionLookupList[21]">
                        <span class="sectionCheckboxLabel">23</span>
                        <input type="checkbox" id="checkBoxSection_23" v-model="plssSectionList" v-bind:value="plssSectionLookupList[22]">
                        <span class="sectionCheckboxLabel">24</span>
                        <input type="checkbox" id="checkBoxSection_24" v-model="plssSectionList" v-bind:value="plssSectionLookupList[23]">
                    </div>
                    <div class="sectionRow">
                        <span class="sectionCheckboxLabel">30</span>
                        <input type="checkbox" id="checkBoxSection_30" v-model="plssSectionList" v-bind:value="plssSectionLookupList[29]">
                        <span class="sectionCheckboxLabel">29</span>
                        <input type="checkbox" id="checkBoxSection_29" v-model="plssSectionList" v-bind:value="plssSectionLookupList[28]">
                        <span class="sectionCheckboxLabel">28</span>
                        <input type="checkbox" id="checkBoxSection_28" v-model="plssSectionList" v-bind:value="plssSectionLookupList[27]">
                        <span class="sectionCheckboxLabel">27</span>
                        <input type="checkbox" id="checkBoxSection_27" v-model="plssSectionList" v-bind:value="plssSectionLookupList[26]">
                        <span class="sectionCheckboxLabel">26</span>
                        <input type="checkbox" id="checkBoxSection_26" v-model="plssSectionList" v-bind:value="plssSectionLookupList[25]">
                        <span class="sectionCheckboxLabel">25</span>
                        <input type="checkbox" id="checkBoxSection_25" v-model="plssSectionList" v-bind:value="plssSectionLookupList[24]">
                    </div>
                    <div class="sectionRow">
                        <span class="sectionCheckboxLabel">31</span>
                        <input type="checkbox" id="checkBoxSection_31" v-model="plssSectionList" v-bind:value="plssSectionLookupList[30]">
                        <span class="sectionCheckboxLabel">32</span>
                        <input type="checkbox" id="checkBoxSection_32" v-model="plssSectionList" v-bind:value="plssSectionLookupList[31]">
                        <span class="sectionCheckboxLabel">33</span>
                        <input type="checkbox" id="checkBoxSection_33" v-model="plssSectionList" v-bind:value="plssSectionLookupList[32]">
                        <span class="sectionCheckboxLabel">34</span>
                        <input type="checkbox" id="checkBoxSection_34" v-model="plssSectionList" v-bind:value="plssSectionLookupList[33]">
                        <span class="sectionCheckboxLabel">35</span>
                        <input type="checkbox" id="checkBoxSection_35" v-model="plssSectionList" v-bind:value="plssSectionLookupList[34]">
                        <span class="sectionCheckboxLabel">36</span>
                        <input type="checkbox" id="checkBoxSection_36" v-model="plssSectionList" v-bind:value="plssSectionLookupList[35]">
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-3">
                </div>
                <div class="col-md-8" v-show="showSaveBtn">
                    <button name="saveBtn" :disabled="disableSaveBtn" class="btn btn-primary" v-on:click="savePlss" style="width:100px;">Add PLSS</button>
                    <button name="clearBtn" class="btn" v-on:click="clearPlssInput" style="width:100px;">Clear</button>
                </div>
            </div>
            <div v-show="isDebug" style="margin-top: 20px;">
                <div>
                    <h3 class="text-danger">****** Debug ******</h3>
                </div>
                <div>
                    <h4>Validation errors: </h4>
                    <pre>{{ errors }}</pre>
                </div>
                <div>
                    <h4>plssData: </h4>
                    <pre>{{ plssData }}</pre>
                </div>
                <div>
                    <h4>plssSectionList: </h4>
                    <pre>{{ plssSectionList }}</pre>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import meridianService from '../services/lookup/meridianService'

export default {
    name: 'plssComponent',
    props: {
        showTitle: {
            type: Boolean,
            default: true
        },
        showSaveBtn: {
            type: Boolean,
            default: true
        },
        disableSaveBtn: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            default: ''
        }
    },
    data: function () {
        return {
            isDebug: false,
            plssSectionList: [],
            plssSectionLookupList: [],
            meridianList: [],
            plssData: {
                Township: null,
                TownshipDirection: 'N',
                Range: null,
                RangeDirection: 'W',
                MeridianId: '',
                Sections: []
            },
            formReset: true
        }
    },
    created () {
    },
    mounted () {
        loggingService.log(this.isDebug, 'PlssComponent', 'mounted')
        this.loadPlssSectionLookupList()
        this.loadMeridianList()
    },
    methods: {
        loadPlssSectionLookupList () {
            for (var i = 1; i < 37; i++) {
                this.plssSectionLookupList.push(i)
            }
        },
        savePlss () {
            loggingService.log(this.isDebug, 'PlssComponent', 'savePlss')

            //var handle = this
            this.$validator.validateAll('plssComponent').then((isValid) => {
                if (isValid) {
                    loggingService.log(this.isDebug, 'PlssComponent', 'savePlss - form validated')
                    //TODO: Validate that at least one section is selected

                    this.readData()
                    this.$emit('savePlss')
                } else {
                    loggingService.log(this.isDebug, 'PlssComponent', 'savePlss - invalid form')
                }
            })
        },
        readData () {
            var i = 0
            this.plssData.Sections = []
            this.plssSectionList.forEach(section => {
                i++
                loggingService.log(this.isDebug, 'PlssComponent', 'Section List is check (' + i + '): ' + section)
                this.plssData.Sections.push(section)
            })
        },
        loadMeridianList () {
            loggingService.log(this.isDebug, 'PlssComponent', 'loadMeridianList')

            var handle = this
            meridianService.listLookup(this.$http).then(function (response) {
                handle.meridianList = response.data
                return response
            })
        },
        createNewPlssLocation () {
            return {
                Township: '',
                TownshipDirection: '',
                Range: '',
                RangeDirection: '',
                MeridianId: '',
                Sections: []
            }
        },
        clearPlssInput () {
            this.plssData = {
                Township: '',
                TownshipDirection: '',
                Range: '',
                RangeDirection: '',
                MeridianId: '',
                Sections: []
            }
            this.plssSectionList = []
            this.formReset = false
            this.$nextTick().then(() => {
                this.formReset = true
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// PlssComponent.vue?739a497a